import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/About',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/System',
    name: 'System',
    component: () => import(/* webpackChunkName: "about" */ '../views/SystemView.vue')
  },
  {
    path: '/OEE',
    name: 'OEE',
    component: () => import(/* webpackChunkName: "about" */ '../views/OEEView.vue')
  },
  {
    path: '/PlanStop',
    name: 'PlanStop',
    component: () => import(/* webpackChunkName: "about" */ '../views/PlanStopView.vue')
  },
  {
    path: '/PlanManufactureTime',
    name: 'PlanManufactureTime',
    component: () => import(/* webpackChunkName: "about" */ '../views/PlanManufactureTimeView.vue')
  },
  {
    path: '/Unqualified',
    name: 'Unqualified',
    component: () => import(/* webpackChunkName: "about" */ '../views/UnqualifiedView.vue')
  },
  {
    path:'/MappingTable',
    name:'MappingTalbe',
    component: () => import(/* webpackChunkName: "about" */ '../views/MappingTable.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
